export default __webpack_public_path__ + "static/media/sello.69714f04.png";